import {
  APP_LOAD,
  REDIRECT,
  HOME_PAGE_UNLOADED
} from '../constants/actionTypes';

const defaultState = {
  appName: 'KapuAkmens.lv',
  token: null,
  viewChangeCounter: 0,
  lang: 'LV'
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        appLoaded: true
      };
    case REDIRECT:
      return { ...state, redirectTo: null };
    case HOME_PAGE_UNLOADED:
      return { ...state, viewChangeCounter: state.viewChangeCounter + 1 };
    case "SET_LANGUAGE":
      let x = { ...state, lang: action.language };
      return x;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/common.js